<template>
   <article>
    <ul class="tab-service-detail">
      <li v-for="(item, index) in tabList" @click="onShiftTab(item)" :class="{on:item.on}" :key="index">
        <a href="javascript:void(0);">{{item.name}}</a>
      </li>
    </ul>
    <div class="blank"></div>
    <div class="car-all">
      <cell title="DCC线索分析" class="top-title" v-if="tabList[0].on && tabList[0].id === 'date'">
        <span slot="after-title" class="title-date">{{"|&nbsp;&nbsp;" + day}}</span>
        <button
          slot="child"
          @click="tabChange({filter: 'today', bool: true})"
          :class="{'btn-select': flagA, 'btn-default': !flagA}">今天</button>
        <button
          slot="child"
          @click="tabChange({filter: 'yestoday', bool: false})"
          :class="[{'btn-select': !flagA, 'btn-default': flagA}, 'btn-margin']">昨天</button>
      </cell>
      <cell title="DCC线索分析" class="top-title" v-else>
        <span slot="after-title" class="title-date">{{"|&nbsp;&nbsp;" + day}}</span>
        <button
          slot="child" :class="{'btn-select': flagA, 'btn-default': !flagA}"
          @click="tabChange({filter: 'this_month', bool: true})"
          >本月</button>
        <button
          slot="child"
          @click="tabChange({filter: 'last_month', bool: false})"
          :class="[{'btn-select': !flagA, 'btn-default': flagA}, 'btn-margin']">
          上个月
        </button>
      </cell>
      <p class="table-title">线索转成交统计</p>
      <a-card
        config="clueToDeal"
        first-field="channel"
        ref="clueToDeal"
        :params="params">
        <th slot="title">渠道</th>
      </a-card>
      <p class="table-title">潜客意向车型转成交统计</p>
      <a-card
        class="complex-table"
        config="serieCars"
        ref="serieCars"
        first-field="car_series"
        count="count"
        rate="rate"
        :params="params"
        :is-scroll="true">
        <th slot="title">车系</th>
      </a-card>
      <p class="table-title">客户区域分布转成交统计</p>
      <a-card class="complex-table" :params="params" config="areaConfig" ref="areaConfig" first-field="area" count="count" rate="rate" :is-scroll="true">
        <th slot="title">区域</th>
      </a-card>
      <p class="table-title">客户信息渠道转成交统计</p>
      <a-card class="complex-table" :params="params" config="channelConfig" ref="channelConfig" first-field="channel_source" count="count" rate="rate" :is-scroll="true">
        <th slot="title">信息渠道</th>
      </a-card>
      <p class="table-title">战败原因TOP5</p>
      <div class="intention-level">
        <div class="total-box">
          <div class="total-info">
            <p class="total-num">{{ reasons.total }}</p>
            <p class="total-text">总数合计</p>
          </div>
        </div>
        <div class="progress-levels">
          <div v-for="(item, index) in reasons.items" :key="index">
            <p class="level-name" style="margin-bottom: 0.2rem">{{ item.reason }}</p>
            <flexbox>
              <flexbox-item :span="5/8">
                <x-progress :percent="item.rate * 100" :show-cancel="false"></x-progress>
              </flexbox-item>
              <flexbox-item :span="3/8">
                <span class="level-info">合计:{{ item.total }} &nbsp;&nbsp; 占比:{{ item.rate * 100 + '%' }}</span>
              </flexbox-item>
            </flexbox>
          </div>
        </div>
      </div>
    </div>
   </article>
</template>
<script>
import util from '../../common/util'
import { Cell, XProgress, Flexbox, FlexboxItem } from '@lx-frontend/cvux'
import ACard from './components/ACard'
export default {
  components: {
    Cell,
    Flexbox,
    FlexboxItem,
    XProgress,
    ACard
  },
  data () {
    return {
      group: {},
      flagA: true,
      day: util.formatTime(new Date(), 'yyyy-MM'), // 获取当前日期
      tabList: [{
        id: 'date',
        name: '日',
        on: false
      }, {
        id: 'month',
        name: '月',
        on: true
      }],
      params: {
        filter: 'all',
        store_id: this.$route.query.store_id
      },
      reasons: {}
    }
  },
  created () {
    this.getDefeatTop()
    this.getType()
  },
  methods: {
    getType () {
      const type = this.$route.query.type
      let index = 1

      if (type) {
        index = parseFloat(type)
      }

      this.onShiftTab(this.tabList[index])
    },
    onShiftTab (item) {
      this.tabList.forEach((tab) => {
        if (item.id === tab.id) {
          tab.on = true
        } else {
          tab.on = false
        }
      })
      if (item.on && item.id === 'date') {
        this.flagA = true
        this.params.filter = 'today'
        this.getData()
        this.getCurrentTime()
      } else {
        this.flagA = true
        this.params.filter = 'this_month'
        this.getData()
        this.getCurrentTime()
      }
    },
    getData () {
      if (this.$refs.clueToDeal) {
        this.$refs.clueToDeal.query('clueToDeal', this.params)
      }
      if (this.$refs.serieCars) {
        this.$refs.serieCars.query('serieCars', this.params)
      }
      if (this.$refs.areaConfig) {
        this.$refs.areaConfig.query('areaConfig', this.params)
      }
      if (this.$refs.channelConfig) {
        this.$refs.channelConfig.query('channelConfig', this.params)
      }
      this.getDefeatTop()
    },
    getCurrentTime () {
      let date = new Date()
      switch (this.params.filter) {
        case 'last_month':
          let lastMonty = new Date(date.getFullYear(), date.getMonth() - 1, date.getDate())
          this.day = util.formatTime(lastMonty, 'yyyy-MM')
          break
        case 'yestoday':
          let yesterday = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1)
          this.day = util.formatTime(yesterday, 'yyyy-MM-dd')
          break
        case 'today':
          this.day = util.formatTime(date, 'yyyy-MM-dd')
          break
        default:
          this.day = util.formatTime(date, 'yyyy-MM')
      }
    },
    tabChange (newParams) {
      this.params.filter = newParams.filter
      this.flagA = newParams.bool
      this.getData()
      this.getCurrentTime()
    },
    getDefeatTop () {
      this.$rest.dataAnalysis.getDefeatTop(this.params).then(res => {
        if (res.code === 0) {
          this.reasons = res.data
        } else {
          this.showToast(res.message)
        }
      })
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less">
  @import "../../stylesheets/modules/data/carData.less";
  @import "../../stylesheets/modules/data/shopCustomers.less";
  .th-span, .tr-span {
    width: 1.5rem;
    display: inline-block;
  }

</style>
